import moment from 'moment';
import { useNavigate } from 'react-router-dom';

function EvaluationsItem({data}) {
	const navigate = useNavigate();
	const {totals} = data;
	const getTotal = (type) => {
		switch (type) {
			case 'total':
				let t = totals[0] / data.questions.length
				return (Math.round(t)).toFixed(0);
			case 'soft':
				let s = totals[3] / totals[4]
				return (Math.round(s)).toFixed(0);
			case 'hard':
				let h = totals[1] / totals[2]
				return (Math.round(h)).toFixed(0);
			default:
				break;
		}
	}
	const getColorByScore = (score) => {	
		if(score < 45){
			return 'text__danger';
		}else if(score >= 45 && score <= 55){
			return 'text__primary'
		}else if (score >= 56 && score <= 75) {
			return 'text__warning';
		}else{
			return 'text__success';
		}
	}
	return (
		<div className='evaluation__item'>
			<div className="text__left font__15">
				<div className="capitalize">
					<b>Name:</b> {data.name}
				</div>
				<div className="capitalize">
					<b>Surname:</b> {data.surname}
				</div>
			</div>
			<div className="evaluation__item-actions">
				{data.email && 
					<a className="btn btn__secondary btn__sm" href={`mailto: ${data.email}`}>
						<span className="material-icons font__18">
							mail
						</span>
					</a>
				}
				{data.linkedin &&
					<a className="btn btn__secondary btn__sm" href={data.linkedin} target="_blank">
						<img src='https://api.iconify.design/logos:linkedin-icon.svg' width="18" />
					</a>
				}
			</div>
			<hr className="mtop--30"/>
			{data.evaluationDate &&
				<span className="evaluation__item-date">
					{moment(data.evaluationDate).fromNow()}
				</span>
			}
			<div className="flex flex__row">
				<div className="report__score btn btn__light btn__sm">
					<div className="font__12">Overall Score</div>
					<div className="result__item">
						<b className={getColorByScore(getTotal('total'))}>{getTotal('total')}%</b>
					</div>
				</div>
				<div className="report__score btn btn__light btn__sm">
					<div className="font__12">Avg soft skills score</div>
					<div className="result__item">
						<b className={getColorByScore(getTotal('soft'))}>{getTotal('soft')}%</b>
					</div>
				</div>
				<div className="report__score btn btn__light btn__sm">
					<div className="font__12">Avg hard skills score</div>
					<div className="result__item">
						<b className={getColorByScore(getTotal('hard'))}>{getTotal('hard')}%</b>
					</div>
				</div>
			</div>
			<div className="evaluation__item-view">
				<a className='btn btn__primary btn__sm font__13' onClick={() => navigate(`/evaluation/${data.id}`)}>
					View answers
				</a>
			</div>
		</div>
	)
}

export default EvaluationsItem